import { render, staticRenderFns } from "./No13.vue?vue&type=template&id=56e75792&scoped=true"
import script from "./No13.vue?vue&type=script&lang=js"
export * from "./No13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e75792",
  null
  
)

export default component.exports